module.exports = __webpack_public_path__ + "static/impact-of-coronavirus-chart-154ea3fe1b72319d0fb13fabc48d8929.png";